import FequirementsVote from "../pages/requirements-vote/index";
import TvDownload from "../pages/tv-download/index";
import UserManual from "../pages/userManual";


export const routes = [
    { path: "/", component: FequirementsVote },
    { path: "/demand/:meetKey/:token", component: FequirementsVote },
    { path: "/tv-download", component: TvDownload },
    { path: "/user-manual", component: UserManual },
]